
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"140","height":"140","viewBox":"0 0 105 105"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#4a8522"}},[_c('path',{attrs:{"d":"M45.2 12.1C36.3 13.8 25 20.3 25 23.7c0 2.7 3.1 2.4 7.7-.6 22.5-14.9 52.9-.3 55.1 26.5l.5 6.4h-3.7c-2.3 0-3.9.5-4.2 1.5C79.6 59.5 89 74 91 74c1.9 0 11.3-14.8 10.6-16.7-.3-.7-2-1.3-3.9-1.3h-3.4l-1.1-8c-2.7-18.8-15.6-32.6-33.7-35.9-6.6-1.2-8.2-1.2-14.3 0z"}}),_c('path',{attrs:{"d":"M45.8 31.4c-8.5 3.1-13.3 8.5-15 16.7-3.7 18.3 15.3 32.6 32 24 7.5-3.9 11.6-10.8 11.6-19.6 0-6.3-1.7-10.9-5.8-15.3-5.1-5.7-15.8-8.4-22.8-5.8zm18 15C64.2 48.5 51.5 62 49.1 62 47 62 40 55 40 52.9c0-.9.7-2.2 1.5-2.9 1.3-1.1 2.1-.9 4.7 1l3 2.2 4.7-4.6c4.9-5 9.2-6 9.9-2.2z"}}),_c('path',{attrs:{"d":"M7.7 38.7c-2.6 4.2-4.6 8.2-4.3 9 .3.7 2 1.3 4 1.3 3.4 0 3.5.1 4.1 4.7 1.2 9.5 1.5 10.9 4.3 16.8C23.3 86.3 42.2 96 59.3 92.9 68.8 91.2 80 85.2 80 81.7c0-3.1-2.5-2.9-8.4.7-7.2 4.3-14.1 6-22.1 5.4-17.1-1.4-30.9-15.3-32.3-32.4l-.5-6.4h3.7c2.3 0 3.9-.5 4.2-1.5C25.4 45.5 16 31 14 31c-.8 0-3.7 3.5-6.3 7.7z"}})])])
          )
        }
      }
    